import { render, staticRenderFns } from "./asset-image-content.vue?vue&type=template&id=ccd520ac&scoped=true"
import script from "./asset-image-content.ts?vue&type=script&lang=ts&external"
export * from "./asset-image-content.ts?vue&type=script&lang=ts&external"
import style0 from "./asset-image-content.less?vue&type=style&index=0&id=ccd520ac&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd520ac",
  null
  
)

export default component.exports